import dynamic from 'next/dynamic';

import { useWebView } from 'providers/WebViewProvider';

const LazyHydratedFooter = dynamic(() => import('./Footer'));

const Footer = () => {
  const { isFooterActive } = useWebView();

  if (!isFooterActive) {
    return null;
  }

  return <LazyHydratedFooter />;
};

export default Footer;
